// LICENSE_CODE ZON
'use strict';
/*jslint browser:true, es6:true, node:true, react:true*/

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from '../ui/link';
import { use_siteicon } from '../ui/use_siteicon';
import './sitepic.module.less';

const Sitepic = props => {
  useTranslation();
  const activate = props.activate,
        title = props.title,
        link = props.link,
        is_generic = props.is_generic,
        requester = props.requester,
        more = props.more,
        on_get_more = props.on_get_more,
        sitepic_class = props.sitepic_class,
        icon_sources = props.icon_sources,
        image = props.image,
        unblocking = props.unblocking,
        img_load_delay = props.img_load_delay,
        cls = props.cls,
        Promo = props.promo;

  const _use_siteicon = use_siteicon({
    link,
    img_load_delay,
    icon_sources,
    is_generic,
    requester
  }),
        icon_link = _use_siteicon.icon_link,
        loaded = _use_siteicon.loaded,
        on_icon_error = _use_siteicon.on_icon_error,
        on_icon_load = _use_siteicon.on_icon_load;

  if (Promo) return /*#__PURE__*/React.createElement("div", {
    className: "sitepic tile"
  }, /*#__PURE__*/React.createElement(Promo, null));

  const _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        img_err = _useState2[0],
        set_img_err = _useState2[1];

  const on_img_error = event => {
    event.target.onerror = null;
    set_img_err(true);
  };

  const on_click = event => more ? on_get_more(event) : activate(event, props);

  const cls_final = cn('sitepic tile', unblocking && 'unblocking', more && 'sitepic-more', cls);
  const href = more ? '/access/popular' : '#';
  const site = (sitepic_class || '').replace('sitepic_', '');
  const protocol_img = image && image.indexOf('//') == 0 ? 'https:' : '';
  return /*#__PURE__*/React.createElement(Link, {
    className: cls_final,
    href: href,
    onClick: on_click,
    "data-clickid": "sitepic",
    "data-info": JSON.stringify({
      site
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "sitepic-screen"
  }, !img_err && /*#__PURE__*/React.createElement("img", {
    src: image ? protocol_img + image : image,
    onError: on_img_error,
    alt: "sitepic",
    className: "lazyload"
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('sitepic-icon', !loaded && 'loading')
  }, !more && /*#__PURE__*/React.createElement("img", {
    src: icon_link,
    onError: on_icon_error,
    onLoad: on_icon_load,
    alt: "sitepic",
    className: "lazyload"
  })), /*#__PURE__*/React.createElement("div", {
    className: "lock"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lock-shadow"
  }), /*#__PURE__*/React.createElement("div", {
    className: "lock-handle handle-left"
  }), /*#__PURE__*/React.createElement("div", {
    className: "lock-handle handle-right"
  }), /*#__PURE__*/React.createElement("div", {
    className: "lock-body"
  }), /*#__PURE__*/React.createElement("div", {
    className: "lock-dashes"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dash"
  }), /*#__PURE__*/React.createElement("div", {
    className: "dash"
  }), /*#__PURE__*/React.createElement("div", {
    className: "dash"
  }))), !!unblocking && /*#__PURE__*/React.createElement("div", {
    className: "load-spinner"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "spinner",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(250, 100, 0, 0.8",
    offset: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(250, 100, 0, 0.05",
    offset: "1"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "path",
    cx: "30",
    cy: "30",
    r: "25",
    fill: "none",
    stroke: "url(#grad)",
    strokeWidth: "4"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "sitepic-title"
  }, title));
};

export { Sitepic };